<template>
  <!--header-->
  <div class="header headers">


    <div class="header_top">
    
      <div class="theHeadWidth">
        <div class="header_tops">
          <div class="header_logo">
            <router-link to="/">
              <img src="../assets/image/logonew.png" alt="" />

            </router-link>
           
          </div>

         <!--   <div class="header_search">
         

           <input type="text" placeholder="请输入想搜索的内容..." class="theSearchInput" v-model="searchData.searchContent" />
            <input type="button" class="searchbutton" value="搜索" />
          
          </div> -->

          <div class="header_right" v-if="!userName">
            <span class="loginAvatar">
              <img src="../assets/image/loginicos.png" alt="" />
            </span>
            <span class="theHeadLogin">
              <a href="http://120.46.140.235:9011"> 登录</a> </span>
            <!-- <span class="theHeadVerticalBar"></span>
            <span class="theHeadLogin">
              <router-link to="#">注册</router-link>
            </span> -->
          </div>

          <div class="header_right" v-if="userName">
            <span class="loginAvatar">
              <img src="../assets/image/loginico.png" alt="" />
            </span>
            <span class="theHeadLogin">
              <span class="loginName">
                <router-link to="/teachersPersonalCenter">{{
                userName
                }}</router-link>
              </span>
              <span class="loginOut" @click="loggedOut()">退出</span>
            </span>
          </div>
        </div>
      </div>

    </div>



    <div class="roundFigureCode">
        <swiper class="swiper-container" :pagination="swipeset.pagination" :autoplay="swipeset.autoplay">
          <swiper-slide class="swiper-slide">
            <img class="roundFigureImageStyle" src="../assets/image/3.jpg" alt="">
          </swiper-slide>
         
          <swiper-slide class="swiper-slide">
            <img class="roundFigureImageStyle" src="../assets/image/jiaozhuanbg_01.jpg" alt="">
          </swiper-slide>
          <swiper-slide class="swiper-slide">
            <img class="roundFigureImageStyle" src="../assets/image/2.jpg" alt="">
          </swiper-slide>
         
          <swiper-slide class="swiper-slide">
            <img class="roundFigureImageStyle" src="../assets/image/1.jpg" alt="">
          </swiper-slide>
         

         
          <!-- 如果需要分页器 -->
          <div class="swiper-pagination">1</div>
          <!-- 如果需要导航按钮 左右箭头。如果放置在swiper-container外面，需要自定义样式。-->
          <!-- <div class="swiper-button-prev"></div>
                <div class="swiper-button-next"></div> -->
          <!-- 如果需要滚动条 -->
          <!-- <div class="swiper-scrollbar"></div> -->
        </swiper>
      </div>






  </div>





  <!--头部结束-->
</template>

<script>

import { ref, reactive } from "vue";
import router from "@/router";
import { useRouter } from "vue-router";


//轮播图
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/swiper-bundle.css";
export default {
  components: {
    //轮播图
    Swiper,
    SwiperSlide,
  },
  setup() {
    const router = useRouter();
    const userName = localStorage.getItem("userName");


    const theColumnList = ref([
      {
        title: "首页",
        url: "/",
      },
      {
        title: "实验项目",
        url: "/theListOf",
      },
      {
        title: "最新资讯",
        url: "/newlist",
      },
      {
        title: "共享排行",
        url: "/shareRanking",
      },
    ]);
    const currentIndex = ref(parseInt(localStorage.getItem("tABWhich")));
    const columnClick = (index) => {
      localStorage.setItem("tABWhich", index);
      currentIndex.value = parseInt(localStorage.getItem("tABWhich"));
      console.log(666, index)
      console.log(777, parseInt(currentIndex.value))
    };

    //退出登陆
    const loggedOut = () => {
      localStorage.removeItem("userName");
      localStorage.removeItem("token");
      localStorage.removeItem("userId");
      localStorage.removeItem("whetherTheLogin");
      router.push("/");
      setTimeout(function () {
        location.reload();
      }, 500);
    };

    //点击搜索
    const searchData = reactive({
      searchContent: null,

    });
    const atTheTopOfTheSearch = (value) => {
      localStorage.setItem("tABWhich", 1);
      localStorage.setItem("searchContent", value);
      searchData.searchContent = value;

      router.push({
        path: "/theListOf",
        query: { theSearchCriteria: value },
      });
      setTimeout(function () {
        location.reload();
      }, 50);
    };






    const onSwiper = (swiper) => {
      console.log(swiper);
    };
    const onSlideChange = () => {
      console.log('slide change');
    };



    //轮播图
    const swipeset = reactive({

      autoplay: {
        autoplay: true,
        disableOnInteraction: true,// 鼠标滑动后继续自动播放   
        delay: 4000, //4秒切换一次
      },
      speed: 500, //切换过渡速度
      loop: true,
      slidesPerView: "auto", //解决最后一张切换到第一张中间的空白
      centeredSlides: true, //设置slide居中
      spaceBetween: 20,
      coverflowEffect: {
        // rotate: 0, //slide做3d旋转时Y轴的旋转角度。默认50。
        stretch: 50, //每个slide之间的拉伸值（距离），越大slide靠得越紧。 默认0。
        depth: 100, //slide的位置深度。值越大z轴距离越远，看起来越小。 默认100。
        modifier: 1, //depth和rotate和stretch的倍率，相当于            depth*modifier、rotate*modifier、stretch*modifier，值越大这三个参数的效果越明显。默认1。
        // slideShadows: false, //开启slide阴影。默认 true。
      },
      navigation: {
        nextElRef: ".swiper-button-next",
        prevElRef: ".swiper-button-prev",
      },

      pagination: { clickable: true },

    })





    return {
      searchData,
      atTheTopOfTheSearch,
      theColumnList,
      currentIndex,
      columnClick,
      userName,
      loggedOut,
      //轮播图
      onSwiper,
      onSlideChange,
      swipeset,
    };
  },

  name: "headerTop",
};
</script>

<style scoped>
.underTheDesignedHomePage {
  margin-top: 20px;
  margin-bottom: 50px;
}

.header_right a {
  color: #a50c0d;
}
.header_right{
  margin-top: 40px !important;
}

.header_search {
  width: 360px;
  height: 40px;
  float: left;
  border: 2px solid #a50c0d;
  margin-top: 51px;
  margin-left: 94px;
  background: #fff;
}

.header {
  height: 610px;
  position: relative;
}

.loginOut {
  color: #a50c0d;
  margin-left: 8px;
  cursor: pointer;
}
.header_top {
	height: 150px;
	background-image: linear-gradient(to bottom, rgb(255, 255, 255), #fff0);
	z-index: 999999;
	position: relative;
}
.roundFigureCode {
	position: relative;
  bottom: 147px;
	
}
.header_bootom {
  width: 1200px;
  margin: 0 auto;
  background: #FFF;
  border-radius: 20px;
  padding: 23px 50px 23px 50px;
  height: 434px;
}

.header_title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 20px;
}

.header_ul ul li {
  float: left;
  margin-right: 20px;
  margin-bottom: 15px;
}
.roundFigureImageStyle {
	width: 100%;
	height: 576px;
}
</style>